/**
 * Builds a Google Maps search URL from a human-readable address string.
 * Opens the Maps web app on desktop or triggers the native Maps app on mobile.
 *
 * @param address - Full address to search (e.g. "Rua X, 123, Centro, Natal, RN")
 * @returns Fully-qualified Google Maps URL, or empty string if address is blank
 */
export function buildGoogleMapsLink(address: string): string {
  const trimmed = address.trim();
  if (!trimmed) return '';
  const encoded = encodeURIComponent(trimmed);
  return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}
